import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValues, SearchBuilderResponse, SearchParam } from '@core/models';
import { SearchorganizationService, SearchQueryBuilderService, MemberSearchService, SessionSecurityService, LoaderService, ApplicationService } from '@shared/services';
import { ToastrService } from 'ngx-toastr';
import { AppMessages } from '@core/constants';
import { UntypedFormControl } from '@angular/forms';
import { MatSelect as MatSelect } from '@angular/material/select';
import { Subject } from 'rxjs';
import { map, mergeMap, take, takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-search-query-builder',
    templateUrl: './search-query-builder.component.html',
    styleUrls: ['./search-query-builder.component.scss'],
    standalone: false
})
export class SearchQueryBuilderComponent implements OnInit {

  constructor(private searchQueryBuilderService: SearchQueryBuilderService, private memberSearchService: MemberSearchService,
    private searchorganizationService: SearchorganizationService, private toastr: ToastrService,
    private sessionSecurityService: SessionSecurityService, private loaderService: LoaderService,
    private applicationService: ApplicationService) { }

  //input value for member search/approval queue
  @Input() childData: string;

  //event emitter for sending search params
  @Output() sendSearchParam: EventEmitter<any> = new EventEmitter();

  /** control for the selected bank */
  public bankCtrl: UntypedFormControl = new UntypedFormControl();

  /** control for the MatSelect filter keyword */
  public bankFilterCtrl: UntypedFormControl = new UntypedFormControl();

  /** list of banks filtered by search keyword */
  // public filteredBanks: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  @ViewChild('singleSelect') singleSelect: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  //search parameter data
  searchCountParams = 1;
  searchBuilderResponses: SearchBuilderResponse[] = [];
  dropDownSourceModifiedList: any;
  searchParms: SearchParam[] = [];

  //variables for dropdown validations
  addSearchLimitReached = false;
  IsInEditMode = false;
  showSearchButton = false;
  searchLoad = false;
  IsLoaded = false;
  InValidSearch = false;
  parameterLength: number;
  isOrganization = false;
  isEditOrganization = false;
  isAdminandClubUser = true;
  isApplicationOwner = true;
  isAccountApproverUser = false;
  isDodUser = false;
  isMilitaryOfficial = false;
  isBgcaAlliance = false;
  isCEO = false;
  isCPO = false;
  isInitialSearch = true;

  //variables for user search
  userDetails: any;
  orgID: any;
  orgName: any;
  activeOrganization: any;
  isNavigated = 'false';
  organizationList: any;
  filterOrganizationList: any;
  sitesList: any;
  sites: any = [];
  IsAppAllow = false;
  applicationSelected: any;
  applicationDropDownData: any = [];

  //form controls
  accountStatuses: ControlValues[] = [];
  myOrganization: ControlValues[] = [];
  affiliations: ControlValues[] = [];
  positions: ControlValues[] = [];
  siteValues: ControlValues[] = [];
  delegate: ControlValues[] = [];


  ngOnInit() {

    // Show Loader
    this.loaderService.isLoading.next(true);

    this.isNavigated = 'false';

    this.bankFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });


    //Load Application data
    if (this.childData === 'memberSearch') {
      this.applicationService.getCEOApplications().subscribe((data) => {
        this.applicationDropDownData = data
      })
    }

    // Method to get user Details
    const userId = this.sessionSecurityService.getObject<string>('UserId');
    this.memberSearchService
      .getMyInfo(userId)
      .pipe(
        take(1),
        map((me: any) => {
          if (me) {
            this.userDetails = me;
            this.activeOrganization = this.userDetails.activeOrganizationID;

            if (me.roles.indexOf('PortalAdmin') > -1) {
              this.IsInEditMode = true;
              this.showSearchButton = false;
            } else if (
              me.roles.indexOf('ApplicationOwner') > -1 ||
              me.roles.indexOf('NationalStaff') > -1
            ) {
              this.IsInEditMode = true;
              this.showSearchButton = false;
            } else if (me.roles.indexOf('AccountApprover') > -1) {
              this.IsInEditMode = true;
              this.showSearchButton = false;
            } else if (
              me.roles.indexOf('ChiefProfessionalOfficers') > -1 ||
              me.roles.indexOf('CEODelegate') > -1 ||
              me.roles.indexOf('ChiefVolunteerOfficer') > -1 ||
              me.roles.indexOf('RegionalServiceDirectors') > -1
            ) {
              this.IsInEditMode = false;
              this.showSearchButton = true;
              this.isCEO = true;
            } else {
              this.IsInEditMode = true;
              this.showSearchButton = false;
            }
          }
        }),
        mergeMap((user) =>
          // Get the Searchable field name and type from API
          this.searchQueryBuilderService.getSearchBuilderParam(this.childData)
        )
      )
      .pipe(take(1))
      .subscribe((resp: any) => {
        this.searchBuilderResponses = resp;
        this.dropDownSourceModifiedList = resp;
        this.parameterLength = this.searchBuilderResponses.length;

        this.setAccountStatusQueryParams();
        this.setOrganizationParams(this.userDetails);
        this.setAffiliationQueryParms(this.userDetails);

        this.setDelegateQueryParms();
        this.setPositionQueryParms();

        this.isCPO = this.userDetails.roles.includes('ChiefProfessionalOfficers');

        // Hide loader 
        this.loaderService.isLoading.next(false);
      });
    this.checkSearchLimit();
  }

  // Method to fetch the search limit for Search operations
  checkSearchLimit() {
    if (this.searchCountParams === this.searchBuilderResponses.length) {
      this.addSearchLimitReached = true;
    } else {
      this.addSearchLimitReached = false;
    }
  }

  filterBanks() {
    if (!this.organizationList) {
      return;
    }
    // get the search keyword
    let search = this.bankFilterCtrl.value;
    this.searchOrg(search);
  }


  searchOrg(search) {
    this.filterOrganizationList = this.organizationList.filter(bank => bank.orgOrSiteName && bank.orgOrSiteName.toLowerCase().indexOf(search && search.toLowerCase()) > -1);

    if (this.filterOrganizationList !== undefined && this.filterOrganizationList.length > 0) {
      this.myOrganization = [];
      this.filterOrganizationList.forEach((val) => {
        this.myOrganization.push({
          Key: val.id + '|' + val.orgOrSiteName,
          Value: val.orgOrSiteName
        });
      });
    }
    // this.getOrganization();
  }

  isDodOrAdmin(userInfo: any) {
    if (userInfo.roles.indexOf('PortalAdmin') > -1) {
      this.isDodUser = false;
      this.isEditOrganization = true;
    }
    else if (userInfo.roles.indexOf('PortalAdmin') > -1 && userInfo.roles.indexOf('RegionalServiceDirectors') > -1) {
      this.isDodUser = false;
      this.isEditOrganization = true;
    }
    else if (userInfo.roles.indexOf('RegionalServiceDirectors') > -1) {
      this.isDodUser = true;
      this.isEditOrganization = false;
    }

  }

  isBgcaAllianceorMilitary(userInfo: any) {
    if (userInfo.roles.indexOf('BGCAAlliance') > -1) {
      this.isBgcaAlliance = true;
      this.isEditOrganization = false;
    }
    else if (userInfo.roles.indexOf('MilitaryApprovingOfficial') > -1) {
      this.isMilitaryOfficial = true;
      this.isEditOrganization = false;
    }
  }

  isAccountApprover(userInfo: any) {
    if (userInfo.roles.indexOf('AccountApprover') > -1) {
      this.isDodUser = false;
      this.isEditOrganization = true;
    }
  }
  // Method to set the default parameters for Search Operation
  setDefaultQueryParams(userInfo: any) {

    this.isNavigated = this.sessionSecurityService.getObject('UserProfileNavigation');
    if (userInfo.roles.indexOf('PortalAdmin') > -1 || userInfo.roles.indexOf('RegionalServiceDirectors') > -1) {
      this.isDodOrAdmin(userInfo);

      this.isAdminandClubUser = true;

      if (this.isNavigated === 'false') {

        if (this.childData === 'memberSearch') {
          this.searchParms.push({
            fieldName: 'PrimaryOrgGlobalID',
            operator: 'startswith',
            value: null
          });
          this.initialSearch();
        }
        else {
          if (this.isDodUser) {
            // Approval Queue
            this.searchParms.push({
              fieldName: 'PrimaryOrgGlobalID',
              operator: 'startswith',
              value: null
            });
            this.searchParms.push({
              fieldName: 'AccountStatus',
              operator: 'startswith',
              value: null
            });
            this.initialSearch();
          }
          else {
            this.IsInEditMode = true; // Display Modify Search button
            this.showSearchButton = false;

            this.searchParms.push({
              fieldName: 'AccountStatus',
              operator: 'startswith',
              value: null
            });

            this.initialSearch();
          }
        }
      } else {
        this.search();
      }
    }
    else if (userInfo.roles.indexOf('AccountApprover') > -1) {
      this.isAccountApprover(userInfo);
      this.isAdminandClubUser = false;
      this.isAccountApproverUser = true;

      if (this.isNavigated === 'false') {
        if (this.childData === 'memberSearch') {
          this.searchParms.push({
            fieldName: 'PrimaryOrgGlobalID',
            operator: 'startswith',
            value: null
          });
          this.initialSearch();
        }
        else {
          this.IsInEditMode = true; // Display Modify Search button
          this.showSearchButton = false;
          this.searchParms.push({
            fieldName: 'AccountStatus',
            operator: 'startswith',
            value: null
          });
          this.initialSearch();
        }
      } else {
        this.search();
      }
    }
    else if (userInfo.roles.indexOf('ChiefProfessionalOfficers') > -1 ||
      userInfo.roles.indexOf('CEODelegate') > -1 || userInfo.roles.indexOf('ChiefVolunteerOfficer') > -1
    ) {
      if (this.childData === 'memberSearch') {

        this.isEditOrganization = false; // Disables Org dropdown
        this.IsInEditMode = true; // to display add button
        this.isAdminandClubUser = true; // not an Admin or Club

        this.orgID = this.activeOrganization.split('|')[0];
        this.orgName = this.activeOrganization.split('|')[1];

        if (this.isNavigated == 'false') {
          this.searchParms.push({
            fieldName: 'PrimaryOrgGlobalID',
            operator: 'startswith',
            value: `${this.activeOrganization}`
          });
          this.searchParms.push({
            fieldName: 'Surname',
            operator: 'startswith',
            value: ''
          });
          this.initialSearch();
        } else {
          this.search();
        }

      } else { // Approval Queue

        this.IsInEditMode = true;
        this.isEditOrganization = true;
        this.showSearchButton = false;
        this.isAdminandClubUser = false;

        this.orgID = this.activeOrganization.split('|')[0];
        this.orgName = this.activeOrganization.split('|')[1];

        if (this.isNavigated == 'false') {
          this.searchParms.push({
            fieldName: 'PrimaryOrgGlobalID',
            operator: 'startswith',
            value: `${this.activeOrganization}`
          });

          this.searchParms.push({
            fieldName: 'AccountStatus',
            operator: 'startswith',
            value: ''
          });

          this.initialSearch();
        } else {
          this.search();
        }
      }

      this.setSiteQueryParms(this.orgID);
    }
    /* Application Owners & but not BGCA Alliance or MilitaryApprovingOfficial */
    else if ((userInfo.roles.indexOf('ApplicationOwner') > -1 && userInfo.roles.indexOf('NationalStaff') > -1) &&
      !(userInfo.roles.indexOf('BGCAAlliance') > -1 || userInfo.roles.indexOf('MilitaryApprovingOfficial') > -1)) {
      this.isEditOrganization = true;
      this.isAdminandClubUser = true;

      if (this.isNavigated === 'false') {
        this.searchParms.push({
          fieldName: 'mail',
          operator: '',
          value: null
        });

        this.initialSearch();
      } else {
        this.search();
      }
    }
    else if (userInfo.roles.indexOf('BGCAAlliance') > -1 || userInfo.roles.indexOf('MilitaryApprovingOfficial') > -1) {
      this.isBgcaAllianceorMilitary(userInfo);
      this.IsInEditMode = true;
      this.isEditOrganization = true;
      this.showSearchButton = false;
      this.isAdminandClubUser = false;
      this.searchParms.push({
        fieldName: 'Affiliation',
        operator: 'startswith',
        value: ''
      });

      this.searchParms.push({
        fieldName: 'AccountStatus',
        operator: 'startswith',
        value: ''
      });

      this.initialSearch();
    }
    /* NationalStaff */
    else if (userInfo.roles.indexOf('NationalStaff') > -1) {
      this.isEditOrganization = true;
      this.isAdminandClubUser = true;

      if (this.isNavigated === 'false') {
        this.searchParms.push({
          fieldName: 'PrimaryOrgGlobalID',
          operator: 'startswith',
          value: null
        });

        this.initialSearch();
      } else {
        this.search();
      }
    }
  }


  setOrganizationParams(userInfo: any) {

    // Organization : Get my Organization and populate in organization field
    const organization = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName === 'PrimaryOrgGlobalID'
    });
    if (this.childData === 'memberSearch') {

      this.searchorganizationService.getUserOrganizations().subscribe(
        data => {
          this.organizationList = data;
          if (this.organizationList !== undefined && this.organizationList.length > 0) {

            this.organizationList.forEach((val) => {
              this.myOrganization.push({
                Key: val.id + '|' + val.orgOrSiteName,
                Value: val.orgOrSiteName
              });
            });

            organization.forEach((value) => {
              value.controlValues = this.myOrganization;
            });
          }
          this.setDefaultQueryParams(userInfo);
        });

    } else {
      this.searchorganizationService.getMyOrganizations().subscribe(
        data => {
          this.organizationList = data;
          if (this.organizationList !== undefined && this.organizationList.length > 0) {

            this.organizationList.forEach((val) => {
              this.myOrganization.push({
                Key: val.id + '|' + val.orgOrSiteName,
                Value: val.orgOrSiteName
              });
            });

            organization.forEach((value) => {
              value.controlValues = this.myOrganization;
            });
          }
          this.setDefaultQueryParams(userInfo);
        });
    }
  }

  getOrganization() {
    if (this.organizationList == null && this.organizationList.length == 0) {
      this.searchorganizationService.getMyOrganizations().subscribe(
        data => {
          this.organizationList = data;
        });
    }
  }

  setAffiliationQueryParms(userInfo: any) {
    // Affiliation Starts

    this.isBgcaAllianceorMilitary(userInfo);
    const affiliation = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName === 'Affiliation'
    });

    if (affiliation.length > 0) {
      const affiliationList: any = this.searchBuilderResponses[5].controlValues;

      affiliationList.forEach((status) => {
        const keys = status.key;
        const value = status.value;
        this.affiliations.push({
          Key: value,
          Value: keys
        });
      });

      if (this.isBgcaAlliance) {
        this.affiliations = this.affiliations.filter(x => x.Value == 'BGCA Alliance');
      }
      else if (this.isMilitaryOfficial) {
        this.affiliations = this.affiliations.filter(x => x.Value == 'Military Youth Center Staff' || x.Value == 'HQ Military Command Level Staff');
      }

      affiliation.forEach((value) => {
        value.controlValues = this.affiliations;
      });

      // Affiliation Ends
    }
  }

  setAccountStatusQueryParams() {
    // Account Status

    const accountStatus = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName === 'AccountStatus'
    });

    if (accountStatus.length > 0) {

      const statusList: any = this.searchBuilderResponses[4].controlValues;

      if (this.childData === 'approvalQueue') {

        statusList.forEach((status) => {

          const keys = status.key;
          const value = status.value;
          if (keys !== 'Active') {
            this.accountStatuses.push({
              Key: value,
              Value: keys
            });
          }
        });
      } else {
        statusList.forEach((status) => {

          const keys = status.key;
          const value = status.value;

          this.accountStatuses.push({
            Key: value,
            Value: keys
          });
        });
      }

      accountStatus.forEach((value) => {
        value.controlValues = this.accountStatuses;
      });
      // Account Status Ends
    }
  }

  setPositionQueryParms() {
    // Position Starts
    const position = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName === 'Position'
    });

    if (position.length > 0) {
      const positionresult = this.searchBuilderResponses.find(({ fieldName }) => fieldName === 'Position');
      const positionList: any = positionresult.controlValues;
      positionList.forEach((status) => {
        const keys = status.key;
        const value = status.value;
        this.positions.push({
          Key: value,
          Value: keys
        });
      });

      position.forEach((value) => {
        value.controlValues = this.positions;
      });
      // Position Ends
    }
  }

  setDelegateQueryParms() {
    // Account Delegate Starts

    let delegates = [];
    if (this.childData === 'memberSearch') {
      delegates = this.searchBuilderResponses.filter((value, index, arr) => {
        return value.fieldName === 'IsDelegate'
      });
    } else {
      delegates = this.searchBuilderResponses.filter((value, index, arr) => {
        return value.fieldName === 'ShowDeleted'
      });
    }

    if (delegates.length > 0) {
      let delegateList: any;
      if (this.childData === 'memberSearch')
        delegateList = this.searchBuilderResponses.find(({ fieldName }) => fieldName === 'IsDelegate');//[7].controlValues;
      else
        delegateList = this.searchBuilderResponses.find(({ fieldName }) => fieldName === 'ShowDeleted');//[7].controlValues;

      delegateList.controlValues.forEach((status) => {
        const keys = status.key;
        const value = status.value;
        this.delegate.push({
          Key: value,
          Value: keys
        });
      });

      delegates.forEach((value) => {
        value.controlValues = this.delegate;
      });
      // Account Delegate Ends
    }
  }

  getSelectedOrganization(globalid) {

    this.setSiteQueryParms(globalid.split('|')[0]);
  }
  setSiteQueryParms(organizationID: any) {
    // Site Starts

    const site = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName === 'PrimarySiteId'
    });

    this.searchorganizationService.getSites(organizationID).subscribe(response => {

      this.sites = response as any;
      this.sitesList = this.sites.site;

      if (this.sitesList !== undefined && this.sitesList.length > 0) {
        this.siteValues = [];
        this.sitesList.forEach((val) => {
          this.siteValues.push({
            Key: val.id + '|' + val.name,
            Value: val.name
          });
        });

        site.forEach((value) => {
          value.controlValues = this.siteValues;
        });
      }
    });
    // Site Ends
  }

  getSelectedFieldName(fieldInfo: any) {

    const searchParamCount = this.searchParms.filter((x) => x.fieldName.includes(fieldInfo.value));

    if (searchParamCount[0].fieldName === 'PrimarySiteId') {
      const paramExists = this.searchParms.filter((x) => x.fieldName.includes('PrimaryOrgGlobalID'));

      if (!paramExists.length) {
        this.toastr.warning(AppMessages.searchQueryOrgValidation);

        const index = this.searchParms.findIndex(
          element => element.fieldName === fieldInfo && element.value === ''
        );
        this.searchParms.splice(index, 1);

        this.searchParms.push({
          fieldName: 'PrimaryOrgGlobalID',
          operator: '',
          value: null
        });
      }
    }

    if (searchParamCount && searchParamCount.length > 1) {
      const index = this.searchParms.findIndex(
        element => element.fieldName === fieldInfo && element.value === ''
      );
      this.searchParms.splice(index, 1);
      this.toastr.warning(AppMessages.searchQueryParamValidation);
    }

    this.searchParms.find(x => x.fieldName === fieldInfo.value).value = '';

    this.loadSearchParams();
  }

  // Add new query param field
  addParam() {

    this.searchCountParams = this.searchCountParams + 1;
    this.checkSearchLimit();
    this.IsLoaded = true;
    this.isInitialSearch = false;

    if (this.searchCountParams <= this.searchBuilderResponses.length) {
      this.searchParms.push({
        fieldName: '',
        operator: '',
        value: ''
      });
    }
    this.loadSearchParams();
    //this.getOrganization();
  }

  loadsessionStorage() {
    this.loadSearchParams();
    if (this.childData === 'memberSearch') {
      this.sessionSecurityService.setObject(this.searchParms, 'memberSearchQuery');
    } else {
      this.sessionSecurityService.setObject(this.searchParms, 'approvalQueueQuery');
    }
  }

  // Remove query param field
  removeParam(index: number) {
    this.checkSearchLimit();
    this.searchCountParams = this.searchCountParams - 1;
    this.searchParms.splice(index, 1);
    this.loadSearchParams();
  }

  // Modify the already selected search fields
  modifySearch() {
    this.IsInEditMode = true;
    this.loadSearchParams();
    this.isNavigated = 'false';
  }

  // Clear all the existing search values
  clearAllSearch() {
    this.searchParms = [];
    this.setDefaultQueryParams(this.userDetails);
    this.bankCtrl.setValue("");
    if (this.childData === 'memberSearch') {

      this.IsAppAllow = false;
      this.applicationSelected = '';

      this.sessionSecurityService.deleteObjectLocalStorage('isAppAllow');
      this.sessionSecurityService.deleteObjectLocalStorage('applicationSelected');

    }
  }

  isAppAllow(value) {
    if (!value.checked) {
      this.applicationSelected = null;
    }
  }

  loadSearchParams() {

    this.searchParms.forEach((val) => {

      const item = this.searchBuilderResponses.filter((value) => { return value.fieldName === val.fieldName; });

      if (val.fieldName == "PrimaryOrgGlobalID" && val.value != null) {
        this.searchOrg(val.value.split('|')[1]);
      }

      if (item.length > 0) {
        val.operator = item[0].filterOperator;
      }
    });


    if (this.childData === 'memberSearch') {
      this.sessionSecurityService.setObject(this.searchParms, 'memberSearchQuery');
    } else {
      this.sessionSecurityService.setObject(this.searchParms, 'approvalQueueQuery');
    }
    this.searchLoad = true;
  }

  removeEmptyParams() {
    this.InValidSearch = false;

    this.searchParms.forEach((item, index) => {
      if (item.value == "" || item.value == null) {
        this.InValidSearch = true;
      }
    });
    if (!this.InValidSearch) {
      this.sendSearchParam.emit(this.searchParms);
    }
    else {
      this.IsInEditMode = true;
      this.toastr.warning('Please provide values for all search parameters to continue search...');
    }
  }

  initialSearch() {
    this.IsLoaded = true;
    this.loadSearchParams();
    //this.removeEmptyParams(); 
  }

  search() {
    this.IsInEditMode = false;
    this.showSearchButton = true;
    this.IsLoaded = true;
    if (this.isNavigated === 'false') {
      this.loadSearchParams();
    }

    // Sending Search params to Parent component
    if (this.childData === 'memberSearch') {
      this.searchLoad = true;
      this.sessionSecurityService.setObjectLocalStorage(this.IsAppAllow, 'isAppAllow');
      this.sessionSecurityService.setObjectLocalStorage(this.applicationSelected, 'applicationSelected');
      if (this.sessionSecurityService.getObject('memberSearchQuery') === '') {
        this.removeEmptyParams(); // this.sendSearchParam.emit(this.searchParms);
      }
      else {
        this.searchParms = this.sessionSecurityService.getObject('memberSearchQuery');
        this.sessionSecurityService.setObject('false', 'UserProfileNavigation');
        this.removeEmptyParams(); //this.sendSearchParam.emit(this.searchParms);
      }
    }
    else {
      this.searchLoad = true;
      if (this.sessionSecurityService.getObject('approvalQueueQuery') === '') {
        this.removeEmptyParams(); // this.sendSearchParam.emit(this.searchParms);
      }
      else {
        this.searchParms = this.sessionSecurityService.getObject('approvalQueueQuery');
        this.sessionSecurityService.setObject('false', 'UserProfileNavigation');
        this.removeEmptyParams(); //this.sendSearchParam.emit(this.searchParms);
      }

    }
  }


  // Get the User Friendly field name from the collection
  getSearchedDisplayFieldInfo(item: SearchParam) {
    if (!item) {
      return '';
    }

    const items = this.searchBuilderResponses.filter((value, index, arr) => {

      return value.fieldName.toLowerCase() === item.fieldName.toLowerCase();
    });

    if (items.length > 0) {
      return items[0].fieldDisplayName;
    }

    return '';
  }

  getUserInputControlType(fieldName: string) {
    const items = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName.toLowerCase() === fieldName.toLowerCase();
    });

    if (items.length > 0) {
      return items[0].controlType;
    }

    return '';
  }

  getUserInputDropdownControlValues(fieldName: string) {
    const items = this.searchBuilderResponses.filter((value, index, arr) => {
      return value.fieldName.toLowerCase() === fieldName.toLowerCase();
    });

    if (items.length > 0) {
      return items[0].controlValues;
    }

    return [] as ControlValues[];
  }

  formatSearchFilterresult(item: string) {
    return item.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  }
}


